import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AdvanceSearchLabels } from '../../models/advance-search/advance-search-label.model';
import { CombineProperties } from '../../models/advance-search/combine-properties.model';
import { IncludeProperties } from '../../models/advance-search/include-properties.model';

@Component({
  selector: 'dop-advance-search',
  templateUrl: './advance-search.component.html',
  styleUrls: ['./advance-search.component.scss']
})
export class AdvanceSearchComponent implements OnInit {

  @Input() advanceSearchLabels: AdvanceSearchLabels;

  @Input() includeProperties: IncludeProperties = new IncludeProperties();

  @Input() combineProperties: CombineProperties = new CombineProperties();

  @Output() refineSearch = new EventEmitter<any>();

  @Output() clearAllFilters = new EventEmitter<any>();

  @Output() includePropertyChanged = new EventEmitter<boolean>();

  constructor() { }

  ngOnInit(): void {
  }

  updateIncludeProperty(property: string) {
    if (this.combineProperties[property] !== '') {
      this.includeProperties[property] = true;
      this.emitChangeInIncludeProperty();
    }
  }

  emitChangeInIncludeProperty() {
    this.includePropertyChanged.emit(true);
  }

  resetCombineSearch(property: string) {
    if (!this.includeProperties[property]) {
      this.combineProperties[property] = '';
    }
    this.emitChangeInIncludeProperty();
  }

  refineButtonClicked() {
    this.refineSearch.emit();
  }

  clearAllButtonClicked() {
    this.clearAllFilters.emit();
  }

}
